import { Building } from 'src/shared/types/building';

export const checkIsEngBuilding = (building: Building): boolean =>
    !building.irish_licence_type &&
    !building.scottish_licence_type &&
    !building.welsh_licence_type &&
    !building.spanish_licence_type;
